import React from "react";
import { Loader, Pagination, Warning } from "@culturehq/components";
import client from "@culturehq/client";

import { useFetch, usePagination } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import Recognition from "components/recognitions/Recognition";
import PageHeader from "components/display/PageHeader";

const Recognitions = () => {
  const [page, onPageClick] = usePagination();
  const { error, fetching, json: { recognitions = [], pagination }, onUpdate } = useFetch(
    () => client.listPendingRecognitions({ page }),
    [page]
  );

  const handleApprove = recognitionId => {
    onUpdate(current => ({
      ...current,
      recognitions: current.recognitions.filter(recognition => recognition.id !== recognitionId)
    }));
  };

  return (
    <>
      <PageHeader title={t("Pending Recognitions")}>
        <Trans>
          Below is a list of all of the pending recognitions for your
          organization. You may click the menu in the upper right of each
          recognition to approve or delete each one.
        </Trans>
      </PageHeader>

      {error && <ErrorMessage error={error} />}

      <Loader loading={fetching}>
        {recognitions.map(recognition => (
          <Recognition
            key={recognition.id}
            recognition={recognition}
            onApprove={handleApprove}
            stickyQuickLinks
          />
        ))}

        {recognitions.length === 0 && (
          <Warning><Trans>There are not currently any pending recognitions.</Trans></Warning>
        )}

        <Pagination {...pagination} onClick={onPageClick} />
      </Loader>
    </>
  );
};

export default Recognitions;
